// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"872fe2b3","324":"24feee63","488":"996c6a8c","649":"d1be2e04","815":"64f02dfb"}[chunkId] + ".chunk.js";
};